<template>
    <v-btn :disabled="disabled" small :loading="load" :text="typeButton === 'text'" :outlined="typeButton === 'outlined'" @click="execute" :color="colorBtn || 'pinkKonect'">
        <v-icon :left="alignIcon" v-if="icon && alignIcon">{{ icon }}</v-icon>
        {{ text }}
        <v-icon :right="!alignIcon && text !== ''" v-if="!alignIcon && icon">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
const props = {
    text: {
        default:'',
        type: String
    },
    onClick: Function,
    icon: {
        default:'',
        type: String
    },
    colorBtn: {
        default:'',
        type: String
    },
    typeButton: {
        default: 'outlined',
        type: String
    },
    alignIcon:{
        default: false,
        type: Boolean
    },
    load:{
        default: false,
        type:Boolean
    },
    disabled:{
        default: false,
        type:Boolean
    }
    
}

export default {
    methods: {
        execute(){
            if(this.onClick){
                this.onClick()
            }
        }
    }
    ,
    props: props
    
}
</script>

<style scoped>
</style>
